import script from "./CircularSankeyChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CircularSankeyChart.vue?vue&type=script&setup=true&lang=js"

import "./CircularSankeyChart.vue?vue&type=style&index=0&id=21d0d4be&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d0d4be"]])

export default __exports__